//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//

/**
 * Create a formatted field display name and api name
 */
export const createUniqueEntityTitle = (displayName: string, apiName: string) => `${displayName} (${apiName})`;
